import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialogClose} from "@angular/material/dialog";
import {ButtonCancelComponent} from "@common-module/buttons/base/concrete/button-cancel/button-cancel.component";
import {ButtonSaveComponent} from "@common-module/buttons/base/concrete/button-save/button-save.component";

@Component({
    selector: 'app-dialog-actions-cancel-save',
  imports: [
    MatDialogClose,
    ButtonCancelComponent,
    ButtonSaveComponent
  ],
    templateUrl: './dialog-actions-cancel-save.component.html'
})
export class DialogActionsCancelSaveComponent {
  @Input() saveDisable = false;
  @Input() showSpinner = false;

  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
